<template>
<div>

<div class="contenttopbar grid px-3 mt-1">
<div class="col-10 md:col-9">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.languages.lang_phrases.muafiyet_sertifikalari}}</h3>
</div>


</div>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card" v-if="!loading">
<div class="grid mt-4">
<div class="col-12">
<Accordion :multiple="true">
    <AccordionTab  v-for="item in exemptioncertificates">

      <template #header>
      <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">{{item.certificatetype.name}}</span>

          <i 
          v-if="isItemFulfiled(item).fulfilled"
          v-badge.success="isItemFulfiled(item).count.toString()" 
          class="pi pi-cloud-upload p-overlay-badge ml-auto" 
          style="font-size: 1.6rem" 
          />
           <i 
          v-else
          v-badge.danger="isItemFulfiled(item).count.toString()" 
          class="pi pi-cloud-upload p-overlay-badge ml-auto" 
          style="font-size: 1.6rem" 
          />
      </span>
    </template>

    <RequiredDocumentUpload 
    v-if="is_admin || is_tech_auditor"
    :exemptioncertificate="item" 
    @newFileUploaded="getDocuments"
    :flowsupplier="$store.state.audit.audit.flowsupplier"
    ></RequiredDocumentUpload>

    <DataTable 
      :value="item.certificatetype.uploads" 
      responsiveLayout="scroll"
      >
      <!--<Column field="certificatetype.name" :header="$store.state.languages.lang_phrases.sertifika_tipi"></Column>-->
      <Column field="certification_body" :header="$store.state.languages.lang_phrases.sertifika_tedarikcisi"></Column>

      <Column field="valid_through" :header="$store.state.languages.lang_phrases.gecerlilik_suresi">
          <template #body="slotProps">
              <p class="my-3">{{ $filters.momentFormat(slotProps.data.valid_through," Do-MM-YYYY ")}}</p>
          </template>
      </Column>

      <Column field="valid_through" :header="$store.state.languages.lang_phrases.kalan_sure">
          <template #body="slotProps">
              <template v-if="getValidDate(slotProps.data.valid_through)<0">
                  <Tag 
                          class="custom-chip" 
                          :value="$store.state.languages.lang_phrases.suresi_dolmus" 
                          style="background-color:#dd4b39"
                          />
              </template>
              <template v-else>
                  <p class="my-3" >{{ getValidDate(slotProps.data.valid_through)}} gün</p>
              </template>
              
          </template>
      </Column>

      <Column field="status" :header="$store.state.languages.lang_phrases.durum">
              <template #body="slotProps">
                  <Tag 
                  v-if="slotProps.data.status=='uploaded'"
                  class="mr-2 mt-1 custom-chip"  
                  :value="this.$store.state.languages.lang_phrases.degerlendirmede" 
                  style="background-color:#3b82f6"
                  />

                  <Tag 
                  v-if="slotProps.data.status=='rejected'"
                  class="mr-2 mt-1 custom-chip"  
                  :value="this.$store.state.languages.lang_phrases.gecersiz" 
                  style="background-color:#a82400"
                  />

                  <Tag 
                  v-if="slotProps.data.status=='accepted'"
                  class="mr-2 mt-1 custom-chip"  
                  :value="this.$store.state.languages.lang_phrases.gecerli" 
                  style="background-color:#4dc247"
                  />         
              </template>
          </Column>
      <Column field="rejection_note" :header="$store.state.languages.lang_phrases.red_sebebi"></Column>
      <Column field="filepath" :header="$store.state.languages.lang_phrases.yuklenen_dosyalar">
          <template #body="slotProps">
              <template v-if="slotProps.data.filepath">
                  <a :href="apihook+slotProps.data.filepath" class="p-button p-button-primary p-button-outlined p-button-sm no_underline" target="_blank"><i class="pi pi-eye mr-2" style="font-size: 1em"></i> Görüntüle</a>

              </template>
              <template v-else>
                  <Tag 
                  class="custom-chip" 
                  :value="$store.state.languages.lang_phrases.yuklu_dosya_yok" 
                  style="background-color:#dd4b39"
                  />
              </template>
              
          </template>
      </Column>

      <template v-if="is_admin || is_tech_auditor">
      <Column field="answer" header="" style="min-width: 8rem">
          <template #body="slotProps">
              <div class="flex align-items-center justify-content-start">
              <template v-if="slotProps.data.status=='uploaded'">
                  <Button :label="$store.state.languages.lang_phrases.reddet" class=" p-button-help p-button-outlined  p-button-sm  hide_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
                  <Button icon="pi pi-times" class=" p-button-help p-button-outlined  p-button-sm  show_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>


                  <Button :label="$store.state.languages.lang_phrases.onayla" class=" p-button-primary p-button-outlined  p-button-sm ml-2 hide_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
                  <Button icon="pi pi-check" class=" p-button-primary p-button-outlined  p-button-sm ml-2 show_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>

                  
              </template>

              <template v-if="slotProps.data.status=='rejected'">
                  <Button :label="$store.state.languages.lang_phrases.onayla" class=" p-button-primary p-button-outlined  p-button-sm hide_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
                  <Button icon="pi pi-check" class=" p-button-primary p-button-outlined  p-button-sm show_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
              </template>

              <template v-if="slotProps.data.status=='accepted'">
                  <Button :label="$store.state.languages.lang_phrases.reddet" class=" p-button-help p-button-outlined  p-button-sm hide_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
                  <Button icon="pi pi-times" class=" p-button-help p-button-outlined  p-button-sm  show_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
              </template>  
              </div>
          </template>
      </Column>    
      </template>

      <template v-if="is_admin || is_tech_auditor || is_auditor">
      <Column field="answer" header="" style="min-width: 8rem">
      <template #body="slotProps">
          <template v-if="slotProps.data.status=='uploaded'">
              <Button :label="$store.state.languages.lang_phrases.sil" class=" p-button-danger p-button-outlined  p-button-sm ml-2 hide_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
              <Button icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm ml-2 show_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
          </template>
          <template v-else>
            <template v-if="is_admin || is_tech_auditor">
                 <Button :label="$store.state.languages.lang_phrases.sil" class=" p-button-danger p-button-outlined  p-button-sm ml-2 hide_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
                <Button icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm ml-2 show_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
            </template>            
          </template>

      </template>
      </Column>
      </template>


      </DataTable>
        

    </AccordionTab>
</Accordion>

</div>
</div>
</div>

<CertificateRejectionModal @rejected="submitRejectDocument" ref="certmodal">


</CertificateRejectionModal>


</div>
</template>

<script>
import moment from "moment";
import CertificateRejectionModal from "../suppliers/CertificateRejectionModal"
import RequiredDocumentUpload from "./RequiredDocumentUpload"

export default {

  name: 'RequiredDocuments',

  data () {
    return {
      loading:true,
      exemptioncertificates:[],
      submitting:false,

    }
  },
  components:{CertificateRejectionModal,RequiredDocumentUpload},
  computed:{
    deletedstate()
    {
        return this.$store.state.ui.deletedstate
    },
    is_supplier()
    {
        let roles = this.$store.state.auth.userroles
        console.log(roles)
        if(roles.includes("supplier"))
        {
            return true
        }
        return false
    },
    is_admin()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("admin"))
        {
            return true
        }
        return false
    },
    is_auditor()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("auditor"))
        {
            return true
        }
        return false
    },
    is_tech_auditor()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("technical_auditor"))
        {
            return true
        }
        return false
    },
   apihook()
    {
        let api =  process.env.VUE_APP_API_HOOK
        api = api.replace("/api/","/")
        return "https://storage.googleapis.com/verifycloud/"
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
        if(newVal)
        {
            this.getDocuments()
        }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    getValidDate(data)
    {
        
        if(data)
        {
            let today = moment()
            let date = moment(data)
            let diff = date.diff(today, 'days')
            return diff
        }
        return 0
    },
    isItemFulfiled(item)
    {
      let obj = {
        count:0,
        fulfilled:false
      }
      if(item.certificatetype.uploads.length)
      {
        obj.count = item.certificatetype.uploads.length

        for (let i = 0; i < item.certificatetype.uploads.length; i++)
        {
          if(item.certificatetype.uploads[i].status=="accepted")
          {
            obj.fulfilled = true
            break
          }
        }
      }

      return obj
    },
    parseAwaitingDocuments()
    {
        let count = 0
        for(let item of this.exemptioncertificates)
        {
            for(let element of item.certificatetype.uploads)
            {
              if(element.status=="uploaded")
              {
                count++
              }
            }
        }
        this.$emit("awaitingDocsCounted",count)
    },
    uploadFile()
    {

    },
    async getDocuments()
    {
        this.exemptioncertificates = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_required_certificates/"+this.$route.params.audit_uuid)
        this.parseAwaitingDocuments()
        this.submitting = false
    },
    async getData()
    {
      this.loading = true
      await this.getDocuments()
      console.log("exemptioncertificates")
      console.log(this.exemptioncertificates)
      this.loading = false
    },
    acceptDocument(id)
    {
        console.log(id)
        //return false
        this.submitting = true
        let formdata = new FormData()       
        this.generalSubmission(formdata,"audit/accept_uploaded_document/"+id,this.getDocuments)
    },
    rejectDocument(id)
    {
        this.$refs.certmodal.showModal(id)
    },
    submitRejectDocument(data)
    {
        console.log(data)        
        this.submitting = true
        let formdata = new FormData() 
        formdata.append("rejection_note",data.rejection_note) 
        this.generalSubmission(formdata,"audit/reject_uploaded_document/"+data.id,this.getDocuments)
    },
  }
}
</script>

<style lang="css" scoped>
</style>